export class Aneuvideo {
    constructor(socket, log) {
        this.socket = socket;
        this.power = true;
        this.videoOutputs = Array(17).fill('1');
        this.asyncHandlers = [
            {
                name: 'firmwareVersion',
                regExp: /r\s*fw\s*version!/i,
                callback: (match) => {
                    this.socket.send('V1.33');
                },
            },
            {
                name: 'getRoute',
                regExp: /r\s*out\s*(\d+)!/i,
                callback: (match) => {
                    const output = parseInt(match[1], 10);
                    this.socket.send(`AV ${this.videoOutputs[output]} -> ${match[1]})`);
                },
            },
            {
                name: 'getRoute 16x16 4K60',
                regExp: /r\s*av\s*out\s*(\d+)!/i,
                callback: (match) => {
                    const output = parseInt(match[1], 10);
                    this.socket.send(`input ${this.videoOutputs[output]} -> output ${match[1]})`);
                },
            },
            {
                name: 'getRoute 8x8 8K60',
                regExp: /r\s*output\s*(\d+)\s*in\s*source!/i,
                callback: (match) => {
                    const output = parseInt(match[1], 10);
                    this.socket.send(`output ${match[1]} -> input ${this.videoOutputs[output]}`);
                },
            },
            {
                name: 'setRoute',
                regExp: /s\s*\s*in\s*(\d+)\s*av\s*out\s*(\d+)!/i,
                callback: (match) => {
                    const output = parseInt(match[2], 10);
                    this.videoOutputs[output] = match[1];
                    this.socket.send(`input ${this.videoOutputs[output]} -> output ${match[2]})`);
                },
            },
            {
                name: 'setRoute 8x8 8K60',
                regExp: /s\s*\s*output\s*(\d+)\s*in\s*source\s*(\d+)!/i,
                callback: (match) => {
                    const output = parseInt(match[1], 10);
                    this.videoOutputs[output] = match[2];
                    this.socket.send(`output ${match[1]} -> input ${this.videoOutputs[output]})`);
                },
            },
            {
                name: 'setRoute 8x8 4K60',
                regExp: />\s*SWT\s*(\d+):(\d+)/i,
                callback: (match) => {
                    const output = parseInt(match[1], 10);
                    this.videoOutputs[output] = match[2];
                    this.socket.send(`< SWT ${match[1]}:${this.videoOutputs[output]})`);
                },
            },
            {
                name: 'powerSet',
                regExp: /s\s*power\s*(on|off|0|1)!/i,
                callback: (match) => {
                    this.power = match[1].toLowerCase() === 'on' || match[1] === '1';
                    this.socket.send(`power ${this.power ? 'on' : 'off'}`);
                },
            },
            {
                name: 'powerSet',
                regExp: /> PWR\s*(T|F|0|1)/i,
                callback: (match) => {
                    this.power = match[1].toLowerCase() === 't' || match[1] === '1';
                    this.socket.send(`< PWR: ${this.power ? 'T' : 'F'}`);
                },
            },
            {
                name: 'powerQuery',
                regExp: /r\s*power!/i,
                callback: (match) => {
                    this.socket.send(`power ${this.power ? 'on' : 'off'}`);
                },
            },
            {
                name: 'statusQuery',
                regExp: /> STA/i,
                callback: (match) => {
                    this.socket.send(`SWT: Status`);
                },
            },
        ];
    }
}
Aneuvideo.emulatorType = 'socketEmulator';
Aneuvideo.key = '-OJsDWjuOTyurwypTw6T';
